import checkCookiesEnabled from '@ui/shared-utils/src/checkCookiesEnabled'
import getInfoFromURL from './getInfoFromURL'
import handleInitError from './handleInitError'
import setupAwsAuth from './setupAwsAuth'
import * as urlBuilder from './urlBuilder'
import { initGTM } from './GTMhelpers'

export default function () {
  checkCookiesEnabled()

  const [urlPrefix, , , locale, headers] = getInfoFromURL()
  initGTM()

  const baseUrl = urlBuilder.getBaseUrl(urlPrefix)
  const url = `${baseUrl}/api/v2/sites?locale=${locale}`

  // We need to call the site api to retrieve siteInfo containing Cognito configuration for initilialising amplify.
  // This allows checkAuthState to use the JWT token for it's request, preventing a duplicate order for users being redirected back from Porta.
  window.fetch(url, { headers })
    .then((response) => response.json())
    .then((response) => {
      window.siteInfo = response
      // Log if country is missing
      if (!window.siteInfo.countryCode) {
        if (window.newrelic) {
          window.newrelic.noticeError(new Error('index.js: Missing country'))
        }
      }
      setupAwsAuth()
    })
    .catch(handleInitError)
}
